// Types
import {UserInfo} from "interfaces/shared/userInfo";

export const defaultUserInfo: UserInfo = {
    isLogged: false,
    userName: "",
    numelchart: 0,
    hrefchart: "",
    htmlHeader: "",
    htmlFooter: "",
    stripeActive: []
};
